import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

let ReactQuill;

// 1569: react-quill require must be inside a conditional, otherwise Canvas Kronos project throws 'ReferenceError: Node is not defined'
if (typeof Node !== 'undefined') {
  ReactQuill = require('react-quill');
}

/**
 * @typedef Props
 * @prop {string} [className]
 */
/**
 * @param {Props & {[x: string]: any;}} props
 */
const MotifRichTextEditor = (props) => {
  const { className = '', ...other } = props;
  const classes = classNames({
    'motif-rich-text-editor': true,
    [className]: true
  });

  return ReactQuill ? (
    <div data-motif-rich-text-editor>
      <ReactQuill className={classes} {...other} />
    </div>
  ) : null;
};

MotifRichTextEditor.propTypes = {
  className: PropTypes.string
};

export { MotifRichTextEditor };
